export type ClientSentryOptions = {
  dsn: string;
  environment: string;
  sendDefaultPii: false;
  tracesSampleRate: 0;
  profileSessionSampleRate: 0;
  replaysSessionSampleRate: 0;
  replaysOnErrorSampleRate: 0;
  dataCollection: {
    userInfo: false;
    cookies: false;
    stackFrameVariables: false;
    httpHeaders: { deny: string[] };
    urlQueryParams: { deny: string[] };
  };
};

/** Error-only options. Returns null when the DSN is unset so the SDK stays off. */
export function buildClientSentryOptions(
  dsnValue: string | undefined,
  nodeEnv: string | undefined
): ClientSentryOptions | null {
  const dsn = (dsnValue || '').trim();
  if (!dsn) return null;

  return {
    dsn,
    environment: (nodeEnv || '').trim() || 'development',
    sendDefaultPii: false,
    tracesSampleRate: 0,
    profileSessionSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    dataCollection: {
      userInfo: false,
      cookies: false,
      stackFrameVariables: false,
      httpHeaders: {
        deny: ['authorization', 'cookie', 'set-cookie', 'proxy-authorization'],
      },
      urlQueryParams: {
        deny: ['token', 'password', 'secret', 'authorization', 'card', 'cvv', 'cvc', 'pan', 'payment'],
      },
    },
  };
}
